import base from "../../base";
import userIsAdmin from "../Shared/functions/userIsAdmin";

export default async function removeTreeFromUser(uid, user, treeID) {
	if (!(await userIsAdmin(uid))) return;

	base.remove(`treePermissions/${user}/${treeID}`);
}
